var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"disabled":_vm.loading || !_vm.selectedBudgets.length,"color":"success","depressed":"","size":"small","loading":_vm.loading},on:{"click":function($event){return _vm.getPDF()}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-printer")]),_vm._v(" Declaração de Atividade \"SLHC\" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }